<div class="formulario">
    <mat-accordion class="example-headers-align">
        <mat-expansion-panel class="panel-filtros">
            <mat-expansion-panel-header class="panel-cabecera">
                <mat-panel-title>FILTROS</mat-panel-title>
                <mat-panel-description>
                    Despliegue para mostrar los filtros.
                    <mat-icon>filter_list</mat-icon>
                </mat-panel-description>
            </mat-expansion-panel-header>

            <form [formGroup]="group2">
                <div class="a-w1-row">
                    <mat-form-field appearance="outline" class="a-w6">
                        <mat-label>Fecha desde</mat-label>
                        <input formControlName="desde" matInput [matDatepicker]="picker5" autocomplete="off"
                            readonly [disabled]="true" (dateChange)="onDateChange($event,'desde','group2')">
                        <mat-datepicker-toggle matIconSuffix [for]="picker5"></mat-datepicker-toggle>
                        <mat-datepicker #picker5 color="primary"></mat-datepicker>
                    </mat-form-field>
                    <mat-form-field appearance="outline" class="a-w6">
                        <mat-label>Fecha hasta</mat-label>
                        <input formControlName="hasta" matInput [matDatepicker]="picker6" autocomplete="off"
                            readonly [disabled]="true" (dateChange)="onDateChange($event,'hasta','group2')">
                        <mat-datepicker-toggle matIconSuffix [for]="picker6"></mat-datepicker-toggle>
                        <mat-datepicker #picker6 color="primary"></mat-datepicker>
                    </mat-form-field>
                    <mat-form-field class="a-w3" appearance="outline">
                        <mat-label>Ejecutivo</mat-label>
                        <mat-icon matSuffix (click)="limpiarControl('group2', 'ejecutivo')">close</mat-icon>
                        <mat-select formControlName="ejecutivo" multiple
                            (selectionChange)="selectAllSelected('group2','ejecutivo')">
                            <input #filtrocliente type="text" placeholder="Buscar"
                                (input)="applyFilters2($event,'ejecutivo')" class="mi-input">
                            <mat-select-trigger>
                                {{ getSelectedEjecutivosNames2() || '' }}
                                <span *ngIf="group2.value.ejecutivo?.length > 1"
                                    class="example-additional-selection">
                                    (+{{ group2.value.ejecutivo.length - 1 }} {{ group2.value.ejecutivo.length
                                    === 2 ?
                                    'otro'
                                    : 'otros' }})
                                </span>
                            </mat-select-trigger>
                            <mat-option *ngFor="let topping of FilterEjecutivosGroup2"
                                [value]="topping.codigo">{{
                                topping.nombre
                                }}</mat-option>
                        </mat-select>
                    </mat-form-field>
                    <mat-form-field class="a-w6" appearance="outline">
                        <mat-label>POL</mat-label>
                        <input type="text" matInput formControlName="pol" [matAutocomplete]="autoDestinoG2"
                            (input)="Group2PuertoDestino()">
                        <mat-icon matSuffix (click)="limpiar('pol', 'group2')">close</mat-icon>
                        <mat-autocomplete #autoDestinoG2="matAutocomplete"
                            (optionSelected)="Group2DestinoSeleccionado($event)">
                            <ng-container *ngFor="let option of Group2ListaPuertosDestino">
                                <mat-option [value]="option.nombre">
                                    {{ option.nombre }}
                                </mat-option>
                            </ng-container>
                        </mat-autocomplete>
                    </mat-form-field>
                    <mat-form-field class="a-w6" appearance="outline">
                        <mat-label>POD</mat-label>
                        <input type="text" matInput formControlName="pod" [matAutocomplete]="autoOrigen"
                            (input)="Group2PuertoOrigen()">
                        <mat-icon matSuffix (click)="limpiar('pod', 'group2')">close</mat-icon>
                        <mat-autocomplete #autoOrigen="matAutocomplete"
                            (optionSelected)="Group2OrigenSeleccionado($event)">
                            <ng-container *ngFor="let option of Group2ListaPuertosOrigen">
                                <mat-option [value]="option.nombre">
                                    {{ option.nombre }}
                                </mat-option>
                            </ng-container>
                        </mat-autocomplete>
                    </mat-form-field>
                </div>
                <div class="a-w1-row">
                    <mat-form-field class="a-w3" appearance="outline">
                        <mat-label>Clientes</mat-label>
                        <mat-icon matSuffix (click)="limpiarControl('group2', 'cliente')">close</mat-icon>
                        <mat-select formControlName="cliente" multiple
                            (selectionChange)="selectAllIfAllSelected()">
                            <input #filtrocliente type="text" placeholder="Buscar"
                                (input)="applyFilters2($event,'cliente')" class="mi-input">
                            <mat-select-trigger>
                                {{ group2.value.cliente[0] || '' }}
                                <span *ngIf="group2.value.cliente?.length > 1"
                                    class="example-additional-selection">
                                    (+{{ group2.value.cliente.length - 1 }} {{ group2.value.cliente.length === 2
                                    ?
                                    'otro'
                                    : 'otros' }})
                                </span>
                            </mat-select-trigger>
                            <mat-option *ngFor="let topping of FilterClientesGroup2" [value]="topping.nombre">{{
                                topping.nombre
                                }}</mat-option>
                        </mat-select>
                    </mat-form-field>
                    <mat-form-field class="a-w3" appearance="outline">
                        <mat-label>Linea</mat-label>
                        <mat-icon matSuffix (click)="limpiarControl('group2', 'linea')">close</mat-icon>
                        <mat-select formControlName="linea" multiple>
                            <input #filtrolineas type="text" placeholder="Buscar"
                                (input)="applyFilters2($event,'linea')" class="mi-input">
                            <mat-select-trigger>
                                {{ group2.value.linea[0] || '' }}
                                <span *ngIf="group2.value.linea?.length > 1"
                                    class="example-additional-selection">
                                    (+{{ group2.value.linea.length - 1 }} {{ group2.value.linea.length === 2 ?
                                    'otro'
                                    : 'otros' }})
                                </span>
                            </mat-select-trigger>
                            <mat-option *ngFor="let topping of FilterLineasGroup2" [value]="topping.nombre">{{
                                topping.nombre
                                }}</mat-option>
                        </mat-select>
                    </mat-form-field>
                    <mat-form-field class="a-w6" appearance="outline">
                        <mat-label>ServiceContract</mat-label>
                        <input matInput type="text" placeholder="ServiceContract" formControlName="service">
                    </mat-form-field>
                    <mat-form-field appearance="outline" class="a-w6">
                        <mat-label>ETD</mat-label>
                        <input formControlName="etd" matInput [matDatepicker]="picker7" autocomplete="off"
                            readonly [disabled]="true" (dateChange)="onDateChange($event,'etd','group2')">
                        <mat-datepicker-toggle matIconSuffix [for]="picker7"></mat-datepicker-toggle>
                        <mat-datepicker #picker7 color="primary"></mat-datepicker>
                        <mat-error>Ingrese la fecha desde</mat-error>
                    </mat-form-field>
                </div>
                <div class="items example-full-width-alterno">
                    <button mat-raised-button class="button1"
                        (click)="GenerarReporteSeguimientoCliente()">Buscar</button>
                </div>
            </form>
        </mat-expansion-panel>
    </mat-accordion>
</div>
<br>
<div class="contenido-tabla">
    <table>
        <tr class="cabecera">
            <td class="items-cabecera cabeceras-especiales">
                <div class="cabecera-filtros">Cliente<mat-icon (click)="sortColumn2('cliente')"
                        class="icons-filtro">{{orderFieldName2 == 'cliente' ? statusFieldName2 :
                        'sort'}}</mat-icon></div>
            </td>
            <td class="items-cabecera numeros2 center" *ngIf="mesesArray.includes('01')">
                <div class="cabecera-filtros">Enero<mat-icon (click)="sortColumn2('enero')"
                        class="icons-filtro">{{orderFieldName2 == 'enero' ? statusFieldName2 :
                        'sort'}}</mat-icon></div>
            </td>
            <td class="items-cabecera numeros2 center" *ngIf="mesesArray.includes('02')">
                <div class="cabecera-filtros">Febrero<mat-icon (click)="sortColumn2('febrero')"
                        class="icons-filtro">{{orderFieldName2 == 'febrero' ? statusFieldName2 :
                        'sort'}}</mat-icon></div>
            </td>
            <td class="items-cabecera numeros2 center" *ngIf="mesesArray.includes('03')">
                <div class="cabecera-filtros">Marzo<mat-icon (click)="sortColumn2('marzo')"
                        class="icons-filtro">{{orderFieldName2 == 'marzo' ? statusFieldName2 :
                        'sort'}}</mat-icon></div>
            </td>
            <td class="items-cabecera numeros2 center" *ngIf="mesesArray.includes('04')">
                <div class="cabecera-filtros">Abril<mat-icon (click)="sortColumn2('abril')"
                        class="icons-filtro">{{orderFieldName2 == 'abril' ? statusFieldName2 :
                        'sort'}}</mat-icon></div>
            </td>
            <td class="items-cabecera numeros2 center" *ngIf="mesesArray.includes('05')">
                <div class="cabecera-filtros">Mayo<mat-icon (click)="sortColumn2('mayo')"
                        class="icons-filtro">{{orderFieldName2 == 'mayo' ? statusFieldName2 :
                        'sort'}}</mat-icon></div>
            </td>
            <td class="items-cabecera numeros2 center" *ngIf="mesesArray.includes('06')">
                <div class="cabecera-filtros">Junio<mat-icon (click)="sortColumn2('junio')"
                        class="icons-filtro">{{orderFieldName2 == 'junio' ? statusFieldName2 :
                        'sort'}}</mat-icon></div>
            </td>
            <td class="items-cabecera numeros2 center" *ngIf="mesesArray.includes('07')">
                <div class="cabecera-filtros">Julio<mat-icon (click)="sortColumn2('julio')"
                        class="icons-filtro">{{orderFieldName2 == 'julio' ? statusFieldName2 :
                        'sort'}}</mat-icon></div>
            </td>
            <td class="items-cabecera numeros2 center" *ngIf="mesesArray.includes('08')">
                <div class="cabecera-filtros">Agosto<mat-icon (click)="sortColumn2('agosto')"
                        class="icons-filtro">{{orderFieldName2 == 'agosto' ? statusFieldName2 :
                        'sort'}}</mat-icon></div>
            </td>
            <td class="items-cabecera numeros2 center" *ngIf="mesesArray.includes('09')">
                <div class="cabecera-filtros">Septiembre<mat-icon (click)="sortColumn2('septiembre')"
                        class="icons-filtro">{{orderFieldName2 == 'septiembre' ? statusFieldName2 :
                        'sort'}}</mat-icon></div>
            </td>
            <td class="items-cabecera numeros2 center" *ngIf="mesesArray.includes('10')">
                <div class="cabecera-filtros">Octubre<mat-icon (click)="sortColumn2('octubre')"
                        class="icons-filtro">{{orderFieldName2 == 'octubre' ? statusFieldName2 :
                        'sort'}}</mat-icon></div>
            </td>
            <td class="items-cabecera numeros2 center" *ngIf="mesesArray.includes('11')">
                <div class="cabecera-filtros">Noviembre<mat-icon (click)="sortColumn2('noviembre')"
                        class="icons-filtro">{{orderFieldName2 == 'noviembre' ? statusFieldName2 :
                        'sort'}}</mat-icon></div>
            </td>
            <td class="items-cabecera numeros2 center" *ngIf="mesesArray.includes('12')">
                <div class="cabecera-filtros">Diciembre<mat-icon (click)="sortColumn2('diciembre')"
                        class="icons-filtro">{{orderFieldName2 == 'diciembre' ? statusFieldName2 :
                        'sort'}}</mat-icon></div>
            </td>
            <td class="items-cabecera numeros2 center">
                <div class="cabecera-filtros">Total<mat-icon (click)="sortColumn2('total')"
                        class="icons-filtro">{{orderFieldName2 == 'total' ? statusFieldName2 :
                        'sort'}}</mat-icon></div>
            </td>
        </tr>
        <tr *ngFor="let item of dataReporteSeguimientoCliente; let i = index" class="contenido"
            [ngClass]="{'sombra': (i % 2) == 0}">
            <td class="items-contenido items-ejecutivos cabeceras-especiales">{{item.cliente}}</td>
            <td class="items-contenido center" *ngIf="mesesArray.includes('01')">{{item.enero}}</td>
            <td class="items-contenido center" *ngIf="mesesArray.includes('02')">{{item.febrero}}</td>
            <td class="items-contenido center" *ngIf="mesesArray.includes('03')">{{item.marzo}}</td>
            <td class="items-contenido center" *ngIf="mesesArray.includes('04')">{{item.abril}}</td>
            <td class="items-contenido center" *ngIf="mesesArray.includes('05')">{{item.mayo}}</td>
            <td class="items-contenido center" *ngIf="mesesArray.includes('06')">{{item.junio}}</td>
            <td class="items-contenido center" *ngIf="mesesArray.includes('07')">{{item.julio}}</td>
            <td class="items-contenido center" *ngIf="mesesArray.includes('08')">{{item.agosto}}</td>
            <td class="items-contenido center" *ngIf="mesesArray.includes('09')">{{item.septiembre}}</td>
            <td class="items-contenido center" *ngIf="mesesArray.includes('10')">{{item.octubre}}</td>
            <td class="items-contenido center" *ngIf="mesesArray.includes('11')">{{item.noviembre}}</td>
            <td class="items-contenido center" *ngIf="mesesArray.includes('12')">{{item.diciembre}}</td>
            <td class="items-contenido center">{{item.total}}</td>
        </tr>
        <tr class="totales">
            <td class="items-totales">Total</td>
            <td class="items-totales center" *ngIf="mesesArray.includes('01')">
                {{getTotalCost('enero',dataReporteSeguimientoCliente)}}</td>
            <td class="items-totales center" *ngIf="mesesArray.includes('02')">
                {{getTotalCost('febrero',dataReporteSeguimientoCliente)}}</td>
            <td class="items-totales center" *ngIf="mesesArray.includes('03')">
                {{getTotalCost('marzo',dataReporteSeguimientoCliente)}}</td>
            <td class="items-totales center" *ngIf="mesesArray.includes('04')">
                {{getTotalCost('abril',dataReporteSeguimientoCliente)}}</td>
            <td class="items-totales center" *ngIf="mesesArray.includes('05')">
                {{getTotalCost('mayo',dataReporteSeguimientoCliente)}}</td>
            <td class="items-totales center" *ngIf="mesesArray.includes('06')">
                {{getTotalCost('junio',dataReporteSeguimientoCliente)}}</td>
            <td class="items-totales center" *ngIf="mesesArray.includes('07')">
                {{getTotalCost('julio',dataReporteSeguimientoCliente)}}</td>
            <td class="items-totales center" *ngIf="mesesArray.includes('08')">
                {{getTotalCost('agosto',dataReporteSeguimientoCliente)}}</td>
            <td class="items-totales center" *ngIf="mesesArray.includes('09')">
                {{getTotalCost('septiembre',dataReporteSeguimientoCliente)}}</td>
            <td class="items-totales center" *ngIf="mesesArray.includes('10')">
                {{getTotalCost('octubre',dataReporteSeguimientoCliente)}}</td>
            <td class="items-totales center" *ngIf="mesesArray.includes('11')">
                {{getTotalCost('noviembre',dataReporteSeguimientoCliente)}}</td>
            <td class="items-totales center" *ngIf="mesesArray.includes('12')">
                {{getTotalCost('diciembre',dataReporteSeguimientoCliente)}}</td>
            <td class="items-totales center">{{getTotalCost('total',dataReporteSeguimientoCliente)}}</td>
        </tr>
    </table>
</div>
<div class="a-footer"></div>